import ResolveError from "./ResolveError.mjs";
class ResolverError extends ResolveError {}
export default ResolverError;